module.exports = __webpack_public_path__ + "static/media/MoveMyBike bike transportation solutions.882f26f0.jpg";